import APIService from "./APIService";
import MessageService from "./MessageService";
import { cacheAdminList, getCachedAdminList, makeAdminCacheKey } from './AdminCacheDb';

const SERVICES = {
    APIService,
    MessageService,
    cacheAdminList,
    getCachedAdminList,
    makeAdminCacheKey,
}

export default SERVICES;